// Talking-head avatar client (HeyGen LiveAvatar). We bring our own AI stack — Claude for text,
// ElevenLabs for voice (already wired) — and LiveAvatar only renders the lip-synced video.
import { API_BASE } from './chat'

export type AvatarSessionInfo = {
  session_id: string
  livekit_url: string
  livekit_client_token: string
  ws_url: string
  avatar_id: string
}

let available: boolean | null = null

export async function avatarAvailable(): Promise<boolean> {
  if (available !== null) return available
  try {
    const r = await fetch(`${API_BASE}/v1/avatar/status`)
    available = !!(await r.json()).available
  } catch {
    available = false
  }
  return available
}

export async function startAvatarSession(coach: string): Promise<AvatarSessionInfo | null> {
  try {
    const r = await fetch(`${API_BASE}/v1/avatar/session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ coach }),
    })
    return r.ok ? await r.json() : null
  } catch {
    return null
  }
}

export async function stopAvatarSession(sessionId: string): Promise<void> {
  try {
    await fetch(`${API_BASE}/v1/avatar/session/${encodeURIComponent(sessionId)}/stop`, { method: 'POST' })
  } catch { /* best-effort */ }
}

/** Base64 PCM16 24kHz audio for `text` in the coach's voice — feed straight to the avatar WS. */
export async function fetchAvatarSpeech(text: string, coach: string): Promise<string | null> {
  try {
    const r = await fetch(`${API_BASE}/v1/avatar/speech`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text, coach }),
    })
    if (!r.ok) return null
    return (await r.json()).audio_base64 as string
  } catch {
    return null
  }
}
